import React from 'react';
import {
  Modal,
  ModalBody,
  ModalCloseBtn,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTrigger,
} from '@fiverr-private/overlay';
import { ProgressBar } from '@fiverr-private/dynamic_matching';
import { Divider, Stack } from '@fiverr-private/layout_components';
import { Heading, Text } from '@fiverr-private/typography';
import { List, ListItem } from '@fiverr-private/list';
import { AppI18n } from '../../i18n';
import { CloseModal } from './CloseModal';

export interface HowToMiraModalProps {
  children: React.ReactNode;
}

export const HowToMiraModal = ({ children }: HowToMiraModalProps) => (
  <Modal fullScreenBreakpoint="sm">
    <ModalTrigger>{children}</ModalTrigger>

    <ModalContent size="xl">
      <ModalHeader>
        <AppI18n k="how_to_modal_mira.title" />
        <ModalCloseBtn />
      </ModalHeader>

      <ModalBody>
        <ProgressBar type="numeric" checkboxSize={'24px'} currentStep={3} connectingLine={false}>
          <Stack gap="0.5" direction="column" paddingLeft="2" paddingBottom="4">
            <Text fontWeight="bold" size="b_sm">
              <AppI18n k="how_to_modal_mira.progress.0.title" />
            </Text>
            <Text size="b_sm">
              <AppI18n k="how_to_modal_mira.progress.0.subtitle" />
            </Text>
          </Stack>
          <Stack gap="0.5" direction="column" paddingLeft="2" paddingBottom="4">
            <Text fontWeight="bold" size="b_sm">
              <AppI18n k="how_to_modal_mira.progress.1.title" />
            </Text>
            <Text size="b_sm">
              <AppI18n k="how_to_modal_mira.progress.1.subtitle" />
            </Text>
          </Stack>
          <Stack gap="0.5" direction="column" paddingLeft="2">
            <Text fontWeight="bold" size="b_sm">
              <AppI18n k="how_to_modal_mira.progress.2.title" />
            </Text>
            <Text size="b_sm">
              <AppI18n k="how_to_modal_mira.progress.2.subtitle" />
            </Text>
          </Stack>
        </ProgressBar>

        <Stack marginTop="8" gap="0" direction="column" paddingLeft="0" paddingBottom="8">
          <Stack marginBottom="4">
            <Heading as="h6">
              <AppI18n k="how_to_modal_mira.describe_what_you_need.title" />
            </Heading>
          </Stack>
          <Stack>
            <Text size="b_sm">
              <AppI18n k="how_to_modal_mira.describe_what_you_need.description" />
            </Text>
          </Stack>
          <List marginBottom="4" paddingX="0" paddingTop="2">
            <Stack>
              <ListItem backgroundColor="grey_200" paddingX="4" paddingY="2" borderRadius="lg">
                <Text size="b_sm">
                  <AppI18n k="how_to_modal_mira.describe_what_you_need.description_list.example_1" />
                </Text>
              </ListItem>
            </Stack>
            <Stack>
              <ListItem backgroundColor="grey_200" paddingX="4" paddingY="2" borderRadius="lg">
                <Text size="b_sm">
                  <AppI18n k="how_to_modal_mira.describe_what_you_need.description_list.example_2" />
                </Text>
              </ListItem>
            </Stack>
            <Stack>
              <ListItem backgroundColor="grey_200" paddingX="4" paddingY="2" borderRadius="lg">
                <Text size="b_sm">
                  <AppI18n k="how_to_modal_mira.describe_what_you_need.description_list.example_3" />
                </Text>
              </ListItem>
            </Stack>
          </List>
        </Stack>
      </ModalBody>

      <Divider />

      <ModalFooter>
        <CloseModal />
      </ModalFooter>
    </ModalContent>
  </Modal>
);
